import { render, staticRenderFns } from "./SummaryCardSpecifications.vue?vue&type=template&id=2c0858bb&scoped=true&"
import script from "./SummaryCardSpecifications.vue?vue&type=script&lang=js&"
export * from "./SummaryCardSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCardSpecifications.vue?vue&type=style&index=0&id=2c0858bb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0858bb",
  null
  
)

export default component.exports